import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { hasMinRole } from '../../utils/rbac';

interface Props {
  minRole: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function RoleGuard({ minRole, children, fallback }: Props) {
  const role = useAuthStore((s) => s.user?.role);

  if (!role || !hasMinRole(role, minRole)) {
    return fallback ? <>{fallback}</> : <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
